import * as ActionType from '../constants/ActionType'
import * as api from '../api/api';

export function getImageUpload(id, widgetId) {
    return (dispatch, getState) => {

        if ( isImageUpdateLoaded(getState(), id) ) {

            // Let the calling code know there's nothing to wait for.
            return Promise.resolve();
        } else {
            // Dispatch a thunk from thunk!
             return dispatch(fetchImageUpload(id, widgetId));
        }
    };
}

export function addImageUpload(json) {
    return {
        type: ActionType.ADD_IMAGE_UPLOAD,
        payload: json
    }
}

export function deleteImageUpload(id) {
    return function (dispatch, getState) {

        console.log('DELETE', id);

        dispatch(deleteImageUploadStart());

        api.deleteImageUpload(id)
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(json =>
                dispatch(deleteImageUploadSuccess(id))
            )
         .catch(error => {
             console.log(`Request failed: ${error}`);
         })
        ;
    }
}

export function loadingWidgetSuccess(widgetId) {
    return {
        type: ActionType.LOADING_WIDGET_SUCCESS,
        widgetId: widgetId
    }
}

function isImageUpdateLoaded(globalState, id) {

    let loaded = false;
    if (globalState.imageUpload.data.length > 0) {
        globalState.imageUpload.data.map(entry => {
            if (entry.id.toString() === id.toString()) {
                loaded = true;
            }
        })
    }

    return loaded;
}

function fetchImageUpload(id, widgetId) {
    // Thunk middleware knows how to handle functions.
    // It passes the dispatch method as an argument to the function,
    // thus making it able to dispatch actions itself.

    return function (dispatch, getState) {

        dispatch(requestImageUpload());

        api.getImageUpload(id)
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(json =>
                // We can dispatch many times!
                // Here, we update the app state with the results of the API call.
                dispatch(receiveImageUpload(json, widgetId))
            )
            .then(json =>
                dispatch(loadingWidgetSuccess(widgetId))
            )
            .catch(error => {
               if (error.message === 'Bad Request')  {
                    dispatch(loadingWidgetSuccess(widgetId));
               }
            })
        ;

        // In a real world app, you also want to
        // catch any error in the network call.
    }
}

function requestImageUpload() {
    return {
        type: ActionType.REQUEST_IMAGE_UPLOAD
    }
}

function receiveImageUpload(json, widgetId) {

    return {
        type: ActionType.RECEIVE_IMAGE_UPLOAD,
        payload: json,
        widgetId: widgetId,
    }

}

function deleteImageUploadStart() {
    return {
        type: ActionType.DELETE_IMAGE_UPLOAD
    }
}

function deleteImageUploadSuccess(imageUploadId) {
    return {
        type: ActionType.DELETE_IMAGE_UPLOAD_SUCCESS,
        imageUploadId: imageUploadId
    }
}

function requestImageUploadError() {
    return {
        type: ActionType.REQUEST_IMAGE_UPLOAD_ERROR
    }
}










// WEBPACK FOOTER //
// ./src/js/actions/imageUpload.js